module.exports = __webpack_public_path__ + "img/type1_bg1.f027d008.png";